import React from 'react';
import { openApiFetchGet } from '../../store/openApiFetch';
import {
    Content,
    PanelTable,
    TableBody,
    TableData,
    TableHead,
    TableHeader,
    TableHeadRow,
    TableRow,
    TopbarCrumbActive,
    TopbarLeftOnly,
    Tray,
} from '../elements';
import { Spinner } from '../spinners';
import { useReactAsync } from '../utils/useReactAsync';

async function loadFinishedJobs() {
    const result = await openApiFetchGet('/api/workers/admin/finishedJobs', {});
    return result;
}

export function JobsFinished() {
    const { data, isLoading } = useReactAsync(loadFinishedJobs, {}, []);

    return (
        <>
            <TopbarLeftOnly>
                <TopbarCrumbActive title="Finished jobs" icon="fa-flag-checkered" />
            </TopbarLeftOnly>
            <Content>
                <Tray>
                    {(isLoading && <Spinner />) || (
                        <PanelTable>
                            <TableHead>
                                <TableHeadRow>
                                    <TableHeader>Type</TableHeader>
                                    <TableHeader>Submitted</TableHeader>
                                    <TableHeader>Logs</TableHeader>
                                    <TableHeader>Error logs</TableHeader>
                                </TableHeadRow>
                            </TableHead>
                            <TableBody>
                                {data &&
                                    data.map((item) => (
                                        <TableRow key={item.id}>
                                            <TableData>{item.jobType}</TableData>
                                            <TableData>{item.created_at}</TableData>
                                            <TableData>{item.log}</TableData>
                                            <TableData>{item.errorLog}</TableData>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </PanelTable>
                    )}
                </Tray>
            </Content>
        </>
    );
}
